export default __webpack_public_path__ + "static/media/LOGO_HRC_EQUIDAD_LGBTQ.3c47bd4a.png";